export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de facturas"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de la factura"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar factura ", _interpolate(_named("invoice_code"))])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar la factura?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_invoice_payment_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar pago"])},
          "destroy_invoice_payment_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar el pago?"])},
          "title_invoice_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagos"])},
          "total_number_invoice_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagos"])},
          "new_invoice_payment_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo pago"])},
          "paid_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marcar como pagada"])},
          "no_paid_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marcar como no pagada"])}
        }
      }
    }
  })
}